import React from 'react'
import { Form } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
 
class DatePicker extends React.Component{
 
    render(){
 
        return(
            
                <div className="row">
                    <div className="col-md-4">
                            <Form.Group className= 'date-picker-form'controlId="dob">
                        
                                <InputGroup> 
                                
                                    <Form.Label  id="inputGroup-sizing-default">
                                
                                    </Form.Label> 
                                    
                                </InputGroup>   

                            <Form.Control type="date"  />
                        </Form.Group>
                    </div>
                </div>
            
        )
    }
     
}
 
export default DatePicker;
